import React, { useEffect } from "react";
import Staff from "../../../components/Admin/User/Staff";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../../components/Admin/Layout";
import ChatHistory from "../../../components/Admin/Chat/History";
import ChatLive from "../../../components/Admin/Chat/Live";

const pathPrefix = "/admin/chat";

const AdminChatPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== pathPrefix) return;
    navigate(`${pathPrefix}/live`);
  }, [location.pathname]);

  return (
    <AdminLayout
      title={"Support Chat"}
      tabs={[
        { id: 0, title: "Live", path: `${pathPrefix}/live` },
        { id: 1, title: "History", path: `${pathPrefix}/history` },
      ]}
    >
      <Routes>
        <Route path="/live" element={<ChatLive />} />
        <Route path="/history" element={<ChatHistory />} />
      </Routes>
    </AdminLayout>
  );
};

AdminChatPage.propTypes = {};

export default AdminChatPage;
